
define('text!templates/content/reports/inactive_resellers.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n        <table class="inactive-resellers-list table table-striped">\n\n        </table>\n    </div>\n</div>\n';});

